import { Suspense, useEffect, useState } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import useUser from "../../hooks/useUser/useUser";
import { useTranslation } from "../../i18n/hooks/useTranslation";
import Loading from "../Loading/Loading";
import Modal from "../Modal/Modal";
import HeaderNavBar from "../NavBar/HeaderNavBar";
import MobileMenu from "../NavBar/MobileMenu";
import LayoutStyled from "./LayoutStyled";

const Layout = (): JSX.Element => {
  const { checkStorageToken } = useUser();
  const { t } = useTranslation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  const { isLoading } = useAppSelector((state) => state.ui);

  // Detectar si estamos en la landing page
  const isLandingPage = location.pathname === "/";

  useEffect(() => {
    checkStorageToken();
  }, [checkStorageToken]);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <LayoutStyled isMenuOpen={isMobileMenuOpen} isLandingPage={isLandingPage}>
      {isLoading && <Loading />}

      {/* Solo mostrar header si NO estamos en la landing page */}
      {!isLandingPage && (
        <header
          className="header"
          aria-label={t("app.logo")}
          title={t("app.title")}
        >
          <Link to="/" className="header__logo-container">
            <div className="header__logo">DSF</div>
            <div className="header__sublogo">{t("app.title")}</div>
          </Link>

          <div className="header__actions">
            <HeaderNavBar />

            <button
              className="header__menu-toggle"
              onClick={toggleMobileMenu}
              aria-label="Toggle mobile menu"
              aria-expanded={isMobileMenuOpen}
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </header>
      )}

      {/* Menú móvil desplegable - solo si no estamos en landing */}
      {!isLandingPage && (
        <MobileMenu isOpen={isMobileMenuOpen} onClose={closeMobileMenu} />
      )}

      <Suspense fallback={<Loading />}>
        <main className={`content ${isLandingPage ? "content--landing" : ""}`}>
          <Outlet />
          <Modal />
        </main>
      </Suspense>
    </LayoutStyled>
  );
};

export default Layout;
